import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Field, reduxForm } from 'redux-form';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { isMobile } from 'react-device-detect';
import { green } from '@material-ui/core/colors';

const validate = values => {
    const error  = {}
    if (!values.cedule) {
        error.cedule = "El campo cedula es requerido"
    }
    if (!values.amount) {
        error.amount = "El monto es un campo obligatorio"
    }
    if (!values.description) {
        error.description = "La descripcion es un campo obligatorio"
    }
    return error
}
class ChargesForm extends Component {
    constructor(props) {
      super(props);
      this.state = { openDialog: false  };
      // this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
      if (this.txt) {
        this.txt.focus();
      }
      if (isMobile) {
      }
    }
    openDialog = () => {
        this.setState({openDialog: true})
    }
    render() {
        const { classes, handleSubmit, findCustomer, owner, alert, QR, submitting, loading, valid, onCancel } = this.props;
        const clases = makeStyles(theme => ({
            root: {
              display: 'flex',
              alignItems: 'center',
            },
            wrapper: {
              margin: theme.spacing(1),
              position: 'relative',
            },
            buttonSuccess: {
              backgroundColor: green[500],
              '&:hover': {
                backgroundColor: green[700],
              },
            },
            fabProgress: {
              color: green[500],
              position: 'absolute',
              top: -6,
              left: -6,
              zIndex: 1,
            },
            buttonProgress: {
              color: green[500],
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: -12,
              marginLeft: -12,
            },
          }));
        return (
            <React.Fragment>
                <Typography variant="h6" gutterBottom>
                    { `Solicitar Cobro ${owner}` }
                </Typography>
                <form className={classes.form} onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={3}>
                        <Field
                            withFocus
                            name="cedule"
                            id="cedule"
                            required
                            component={ RenderTextFieldRedux }
                            label="Cedula"
                            fullWidth
                            onChange ={ e => { 
                                ((e.target.value.length === 10) || (e.target.value.length === 13)) &&
                                    findCustomer(e.target.value)
                            } }
                        />
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Field
                                withFocus
                                name="owner"
                                id="owner"
                                disabled
                                component={ RenderTextFieldRedux }
                                label="Propietario"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Field
                                withFocus
                                name="amount"
                                id="amount"
                                required
                                component={ RenderTextFieldRedux }
                                label="Monto"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Field
                                withFocus
                                name="description"
                                id="description"
                                required
                                component={ RenderTextFieldRedux }
                                label="Descripcion"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={6}>
                        <div style = {{position: 'relative', margin: 1}
                        }>
                            <Button variant="contained" type="submit"
                                // when={!pristine && !submitSucceeded}
                                onClick = {() => {this.openDialog()}}
                                fullWidth
                                disabled={!valid || submitting || loading}
                                color="primary"
                                className={classes.submit}>
                                Continuar
                            </Button>
                            { loading && <CircularProgress size={24}
                                    className={clases.buttonProgress}
                                    style = { {
                                        color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: -12,
                                        marginLeft: -12,
                                    }}
                                    />}
                        </div>
                        </Grid>
                        <Grid item xs={6} md={6}>
                           
                                <Button variant="contained" className={classes.button} onClick = { () => onCancel() }>
                                    Cancelar
                                </Button>
                        </Grid>
                        <Grid item xs={12}>
                        </Grid>
                    </Grid>
                </form>
                { alert }
                { QR }
            </React.Fragment>
        )
    }
}
const ChargesReduxForm = reduxForm(
  {
    form: 'ChargesForm',
    validate
  }
)(ChargesForm)

ChargesForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    // customers: PropTypes.object.isRequired,
    findCustomer: PropTypes.func.isRequired,
    owner: PropTypes.string,
    cedule: PropTypes.string,
};
export default setPropsAsInitial(ChargesReduxForm)
// export default ChargesForm;